module.exports = __webpack_public_path__ + "img/Banner_Desk_Fin_Promo.8cb21643.png";